import type { BaseRegistration, Dict, RegistrationDisposer } from 'piral-core'
import { buildName, type GlobalState, type PiralPlugin } from 'piral-core'
import type React from 'react'
import * as actions from './actions'

declare module 'piral-core/lib/types/custom' {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface PiletCustomApi extends PageTopApi {}

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface PiralCustomState {}

  interface PiralCustomActions {
    registerPageTopItem(name: string, value: PageTopRegistration): void
    unregisterPageTopItem(name: string): void
  }

  interface PiralCustomRegistryState {
    pageTopItems: Dict<PageTopRegistration>
  }
}

export interface PageTopRegistration extends BaseRegistration {
  component: () => React.ReactNode
}

export interface PageTopApi {
  registerPageTop(name: string, component: () => React.ReactNode): RegistrationDisposer
  unregisterPageTop(name: string): void
}

function withEmptyPageTopItems() {
  return (state: GlobalState): GlobalState => ({
    ...state,
    registry: {
      ...state.registry,
      pageTopItems: {}
    }
  })
}

export function createPageTopApi(): PiralPlugin<PageTopApi> {
  return (context) => {
    context.defineActions(actions)
    context.dispatch(withEmptyPageTopItems())

    return (_api, target) => {
      const pilet = target.name
      let next = 0

      return {
        registerPageTop(name, component): RegistrationDisposer {
          const internalName = name || next++
          const id = buildName(pilet, internalName)
          context.registerPageTopItem(id, {
            pilet,
            component
          } satisfies PageTopRegistration)
          return () => context.unregisterPageTopItem(id)
        },
        unregisterPageTop(name) {
          const id = buildName(pilet, name)
          context.unregisterPageTopItem(id)
        }
      }
    }
  }
}
